import * as styles from '../NewbuildingCarousel.css';

/** @description Меняет значения стиля для курсора
 * @param on {boolean} триггер
 * @param ref {React.RefObject<HTMLDivElement>} ссылка на элемент
 * @return {void}
 */
export var toggleCursorStyles = function toggleCursorStyles(on, ref) {
  if (on) {
    document.body.classList.add(styles['grabbing-cursor']);
  } else {
    document.body.classList.remove(styles['grabbing-cursor']);
  }

  /* istanbul ignore next */
  if (ref.current) {
    if (on) {
      ref.current.classList.add(styles['grabbing-cursor']);
      ref.current.classList.remove(styles['grab-cursor']);
    } else {
      ref.current.classList.add(styles['grab-cursor']);
      ref.current.classList.remove(styles['grabbing-cursor']);
    }
  }
};